var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaneca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.07,
    height: 10.786,
    viewBox: "0 0 8.07 10.786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12804",
    "data-name": "Group 12804",
    transform: "translate(-1269.55 -221.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12789",
    "data-name": "Group 12789",
    transform: "translate(1269.55 221.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7381",
    "data-name": "Path 7381",
    d: "M3934.092,550.517h3.3c.266,0,.353.1.334.36q-.12,1.641-.238,3.282c-.083,1.139-.165,2.279-.251,3.418a.965.965,0,0,1-.961.894q-2.2.005-4.393,0a.972.972,0,0,1-.959-.92c-.085-1.2-.177-2.392-.264-3.588q-.108-1.477-.213-2.954c0-.068-.015-.136-.017-.2a.254.254,0,0,1,.265-.286c.2,0,.4,0,.6,0Zm1.594,3.807q-.038,1.372-.077,2.744a.238.238,0,0,0,.228.269.243.243,0,0,0,.248-.263q.008-.227.014-.454.06-2.1.12-4.207c.008-.291.019-.582.022-.873a.233.233,0,0,0-.233-.242.243.243,0,0,0-.242.236c0,.023,0,.045,0,.068Q3935.726,552.964,3935.686,554.325Zm-3.215-.008h0q-.045-1.384-.09-2.769a.239.239,0,1,0-.477,0c0,.03,0,.061,0,.091q.071,2.219.142,4.437.016.511.037,1.021a.236.236,0,0,0,.239.237.242.242,0,0,0,.237-.241c0-.026,0-.053,0-.079Q3932.516,555.667,3932.471,554.317Zm1.85,0q0-1.334,0-2.667c0-.045,0-.091,0-.136a.235.235,0,0,0-.463-.031.607.607,0,0,0-.011.135q0,2.7,0,5.4a.572.572,0,0,0,.017.157.234.234,0,0,0,.455-.045,1.433,1.433,0,0,0,.005-.159Q3934.322,555.646,3934.322,554.318Z",
    transform: "translate(-3930.052 -547.688)",
    fill: "#9dacbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7382",
    "data-name": "Path 7382",
    d: "M3928.337,521.892c0-.09-.005-.181,0-.27a1,1,0,0,1,1-.941q1.169,0,2.339,0a1.006,1.006,0,0,1,1,1c0,.071,0,.142,0,.227h1.075a.742.742,0,0,1,.731.912.231.231,0,0,1-.2.2.746.746,0,0,1-.135.009h-7.381c-.25,0-.342-.093-.34-.343a.729.729,0,0,1,.781-.781l1.09,0A.275.275,0,0,0,3928.337,521.892Zm3.73.009c0-.035,0-.058,0-.08.008-.4-.127-.543-.528-.543-.711,0-1.423.007-2.135,0-.355-.005-.549.245-.459.626Z",
    transform: "translate(-3926.421 -520.679)",
    fill: "#9dacbd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaneca);
export default __webpack_public_path__ + "static/media/caneca.b17fe207708c7f04ab77a04380e8e9d0.svg";
export { ForwardRef as ReactComponent };